import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import {
  Grid,
  TextField,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import styled from 'styled-components';

import SahamAccordion from 'components/SahamAccordion';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/messages';
import {
  BENEFICIARY,
  EMPTY_BENEFICIARY_JUDGEMENT_ON_MERITS,
} from 'containers/data-structure';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { get, isEmpty, isNull } from 'lodash';
import {
  ageValidation,
  getAgeBeneficiary,
  isObjectAttributesEmpty,
} from 'containers/PreOpeningPage/utils';
import { IJudgementOnMeritsBeneficiaryInfo } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import { FormContainer } from 'containers/LawyerFeeNote/styled-components';
import { BENEFICIARY_OPTIONS } from 'containers/PreOpeningPage/constants';
import frLocale from 'date-fns/locale/fr';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import moment from 'moment-timezone';
import { DATE_FORMAT, DATE_PICKET_FORMAT } from 'constants/global';
import { FEES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/data-structure';
import { updateShowFees } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  BENEFICIARY_JUDGEMENT,
  CIVIL_JUDGEMENT,
  CIVIL_JUDGEMENT_VICTIM_FIELDS,
  EMPTY_BENEFICIARY_JUDGEMENT,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { CheckBoxForm } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/BeneficiaryInfo';
import BeneficiaryWithoutCompensation from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/BeneficiaryWithNonCompensation/BeneficiaryWithoutCompensation';
import { removeWhiteSpaceFromString } from 'services/utils';

export interface BeneficiaryAccordionProps {
  intl: IntlShape;
  beneficiary?: IJudgementOnMeritsBeneficiaryInfo;
  disableInput: Boolean;
  handleCancel?: Function;
  newBeneficiaries: any;
  handleDelete?: Function;
  handleSubmit?: Function;
  victimKey: string;
  victimId: number;
  setBeneficiariesJudgementOnMerits: Function;
  listing: Listings;
  handleChangeNewBeneficiaries: Function;
  isManager: boolean;
  deceasedVictimsToShow: any;
  setDeceasedVictimsToShow: Function;
  showFees: any;
  setShowFees: Function;
  lossDate?: string;
  handleItemCheckBox: Function;
  judgement: any;
  victim: any;
  index: any;
  judgementOnMerits: any;
  setJudgement: Function;
}

const Container = styled.div`
  .subContainer {
    width: 100% !important;
  }
  .align-right {
    text-align: right;
  }
  .button-left-space {
    margin-left: 15px;
  }
  .max-content {
    width: max-content !important;
  }
  .input-12 {
    width: 100%;
  }
`;

const BeneficiaryAccordion: React.FC<BeneficiaryAccordionProps> = ({
  handleItemCheckBox,
  judgement,
  ...props
}): JSX.Element => {
  const [expanded, setExpanded] = React.useState(true);
  const [beneficiary, setBeneficiary] = React.useState({
    ...EMPTY_BENEFICIARY_JUDGEMENT_ON_MERITS,
    ...props.beneficiary,
  });
  const handleChangeExpanded = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    event.stopPropagation();
    setExpanded(expanded);
  };
  const id = `${props.victim?.id}-${props.index}`;

  const handleDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const dateOfBirth = moment(theDate as Date).format(DATE_FORMAT);

    setBeneficiary({
      ...beneficiary,
      [BENEFICIARY.DATE_OF_BIRTH]: dateOfBirth,
      [BENEFICIARY.AGE]: String(
        getAgeBeneficiary(
          dateOfBirth,
          props.lossDate,
          get(beneficiary, [BENEFICIARY.AGE]),
        ),
      ),
    });
  };
  /* istanbul ignore next */
  const handleChange = (field: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value: any;
    }>,
  ) => {
    const { value, name } = event.target;
    switch (field) {
      case BENEFICIARY.BENEFICIARY_TYPE:
        beneficiary[BENEFICIARY.BENEFICIARY_TYPE] = value;
        break;
      case BENEFICIARY.FIRST_NAME:
        beneficiary[BENEFICIARY.FIRST_NAME] = removeWhiteSpaceFromString(value);
        break;
      case BENEFICIARY.LAST_NAME:
        beneficiary[BENEFICIARY.LAST_NAME] = removeWhiteSpaceFromString(value);
        break;
      case BENEFICIARY.AGE:
        beneficiary[BENEFICIARY.AGE] = value;
        break;
      case BENEFICIARY.PREJUDICE_MATERIEL:
        beneficiary[BENEFICIARY.PREJUDICE_MATERIEL] = value;
        break;
      case BENEFICIARY.PREJUDICE_MORAL:
        beneficiary[BENEFICIARY.PREJUDICE_MORAL] = value;
        break;
      case BENEFICIARY.JUDGEMENT_AMOUNT:
        beneficiary[BENEFICIARY.JUDGEMENT_AMOUNT] = value;
        break;
      case BENEFICIARY.FRAIS:
        !isEmpty(value)
          ? updateShowFees(
              props.victimId,
              props.setShowFees,
              props.showFees,
              true,
              FEES.FUNERAL_VICTIM_FEES,
            )
          : updateShowFees(
              props.victimId,
              props.setShowFees,
              props.showFees,
              false,
              FEES.FUNERAL_VICTIM_FEES,
            );
        beneficiary[BENEFICIARY.FRAIS] = value;
        break;
      case BENEFICIARY.MEDICAL_FFES:
        !isEmpty(value)
          ? updateShowFees(
              props.victimId,
              props.setShowFees,
              props.showFees,
              true,
              FEES.MEDICAL_VICTIM_FEES,
            )
          : updateShowFees(
              props.victimId,
              props.setShowFees,
              props.showFees,
              false,
              FEES.MEDICAL_VICTIM_FEES,
            );
        beneficiary[BENEFICIARY.MEDICAL_FFES] = value;
        break;
      case CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON:
        if (name) {
          beneficiary['beneficiaryWithoutCompensation'] = {
            ...beneficiary?.beneficiaryWithoutCompensation,
            isDeleted: false,
            [name]: value,
          };
        }

        break;
      case CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON:
        if (name) {
          beneficiary['beneficiaryWithoutCompensation'] = {
            ...beneficiary?.beneficiaryWithoutCompensation,
            isDeleted: false,
            [name]: value,
          };
        }

        break;
      default:
        return beneficiary;
    }
    setBeneficiary({
      ...beneficiary,
    });
  };
  const handleSave = () => {
    if (!isObjectAttributesEmpty(beneficiary)) {
      setBeneficiary(EMPTY_BENEFICIARY_JUDGEMENT_ON_MERITS);
      if (props.setBeneficiariesJudgementOnMerits)
        props.setBeneficiariesJudgementOnMerits({
          ...beneficiary,
          victimId: props.victimId,
          isNew: true,
          victimKey: props.victimKey,
        });
      props.handleChangeNewBeneficiaries([
        ...props.newBeneficiaries,
        {
          ...beneficiary,
          isDeletedCompensation:
            !isEmpty(get(beneficiary, 'beneficiaryWithoutCompensation', {})) &&
            !get(
              beneficiary,
              'beneficiaryWithoutCompensation.isDeleted',
              false,
            ),
          victimId: props.victimId,
          isNew: true,
          victimKey: props.victimKey,
        },
      ]);
    }
    props.handleCancel && props.handleCancel();
  };

  const beneficiaryAge = getAgeBeneficiary(
    get(beneficiary, [BENEFICIARY.DATE_OF_BIRTH]),
    props.lossDate,
    get(beneficiary, [BENEFICIARY.AGE]),
  );

  const handleCancel = () => {
    if (props.handleCancel) {
      featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        props.setJudgement({
          ...judgement,
          [`${props.victimId}-${props.index}`]: {
            ...EMPTY_BENEFICIARY_JUDGEMENT,
          },
        });
      props.handleCancel();
    }
  };
  const inputLabel = React.useRef<HTMLLabelElement>(null);

  /* istanbul ignore next */
  const handleChangeCheckBox = (field: string) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const { checked } = event.target;
    setBeneficiary({
      ...beneficiary,
      [field]: checked,
    });
  };
  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <SahamAccordion
            expanded={expanded}
            onChange={handleChangeExpanded}
            title={translate({ ...messages.beneficiaryAccordionTitle }, props, {
              number: ' ',
            })}
            accordionDetailsClassName="beneficiary-content"
          >
            <>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <FormControl className="input-12">
                    <InputLabel
                      ref={inputLabel}
                      id="demo-simple-select-outlined-label"
                    >
                      {translate({ ...messages.qualityBeneficiary }, props)}
                    </InputLabel>
                    <Select
                      onChange={handleChange(BENEFICIARY.BENEFICIARY_TYPE)}
                      name={BENEFICIARY.BENEFICIARY_TYPE}
                      value={get(
                        beneficiary,
                        [BENEFICIARY.BENEFICIARY_TYPE],
                        '',
                      )}
                      labelWidth={60}
                    >
                      {!isEmpty(get(props.listing, 'qualityAyantDroit')) &&
                        get(props.listing, 'qualityAyantDroit').map(
                          (ayantDroit: SagisConfig) => (
                            <MenuItem
                              value={ayantDroit.ItemKey}
                              key={ayantDroit.ItemKey}
                            >
                              {ayantDroit.ItemDescription}
                            </MenuItem>
                          ),
                        )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label={translate({ ...messages.victimFirstName }, props)}
                    className="input-12"
                    name={BENEFICIARY.FIRST_NAME}
                    value={get(beneficiary, [BENEFICIARY.FIRST_NAME]) || ''}
                    onChange={handleChange(BENEFICIARY.FIRST_NAME)}
                    error={false}
                    helperText=""
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label={translate({ ...messages.victimLastName }, props)}
                    className="input-12"
                    name={BENEFICIARY.LAST_NAME}
                    value={get(beneficiary, [BENEFICIARY.LAST_NAME]) || ''}
                    onChange={handleChange(BENEFICIARY.LAST_NAME)}
                    error={false}
                    helperText=""
                  />
                </Grid>
                <Grid item xs={3}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={frLocale}
                  >
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      format={DATE_PICKET_FORMAT}
                      label={translate(
                        { ...messages.beneficiaryBirthDate },
                        props,
                      )}
                      name={BENEFICIARY.DATE_OF_BIRTH}
                      id={BENEFICIARY.DATE_OF_BIRTH}
                      value={dateStringToLocalDate(
                        beneficiary[BENEFICIARY.DATE_OF_BIRTH],
                      )}
                      className="input-4"
                      onChange={handleDateChange}
                      error={
                        dateStringToLocalDate(
                          beneficiary[BENEFICIARY.DATE_OF_BIRTH],
                        ) === 'Invalid date'
                      }
                      helperText={
                        dateStringToLocalDate(
                          beneficiary[BENEFICIARY.DATE_OF_BIRTH],
                        ) === 'Invalid date' &&
                        translate(messages.invalidDate, props)
                      }
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label={translate({ ...messages.beneficiaryAge }, props)}
                    className="input-12"
                    name={BENEFICIARY.AGE}
                    value={beneficiaryAge}
                    onChange={handleChange(BENEFICIARY.AGE)}
                    error={ageValidation(
                      get(beneficiary, [BENEFICIARY.BENEFICIARY_TYPE], ''),
                      get(beneficiary, [BENEFICIARY.AGE]),
                    )}
                    helperText={
                      ageValidation(
                        get(beneficiary, [BENEFICIARY.BENEFICIARY_TYPE], ''),
                        beneficiaryAge,
                      ) &&
                      (Number(
                        get(beneficiary, [BENEFICIARY.BENEFICIARY_TYPE], ''),
                      ) === 3
                        ? translate(messages.agePartnerValidation, props)
                        : translate(messages.ageBeneficiaryValidation, props))
                    }
                    disabled
                  />
                </Grid>
                {featureService.hasFeature(
                  FEATURES.REASONS_FOR_NON_COMPENSATION,
                ) && (
                  <Grid
                    item
                    xs={12}
                    style={{
                      alignSelf: 'self-end',
                      padding: '8px 0px 8px 0',
                      fontWeight: 700,
                    }}
                  >
                    <span style={{ paddingRight: '8px' }}>
                      {translate({ ...messages.checkBoxTitle }, props)}
                    </span>
                    <CheckBoxForm
                      type={BENEFICIARY_JUDGEMENT.COMPENSATION}
                      handleItemCheckBox={handleItemCheckBox}
                      message={translate(
                        messages.compensationRadioLabel,
                        props,
                      )}
                      judgement={judgement}
                      {...props}
                    />
                    <CheckBoxForm
                      type={BENEFICIARY_JUDGEMENT.FORM_REJECTION}
                      handleItemCheckBox={handleItemCheckBox}
                      message={translate(
                        messages.formRejectionRadioLabel,
                        props,
                      )}
                      judgement={judgement}
                      {...props}
                    />
                    <CheckBoxForm
                      type={BENEFICIARY_JUDGEMENT.SUBSTANTIVE_REJECTION}
                      handleItemCheckBox={handleItemCheckBox}
                      message={translate(
                        messages.substantiveRejectionRadioLabel,
                        props,
                      )}
                      judgement={judgement}
                      {...props}
                    />
                  </Grid>
                )}
                {((featureService.hasFeature(
                  FEATURES.REASONS_FOR_NON_COMPENSATION,
                ) &&
                  get(judgement[id], BENEFICIARY_JUDGEMENT.COMPENSATION)) ||
                  !featureService.hasFeature(
                    FEATURES.REASONS_FOR_NON_COMPENSATION,
                  )) && (
                  <>
                    {!get(
                      props.showFees[props.victimId],
                      [FEES.FUNERAL_BENEFICIARY_FEES],
                      false,
                    ) && (
                      <Grid item xs={3}>
                        <TextField
                          label={translate(messages.victimFrais, props)}
                          className="input-12"
                          type="number"
                          name={BENEFICIARY.FRAIS}
                          value={get(beneficiary, [BENEFICIARY.FRAIS], null)}
                          onChange={handleChange(BENEFICIARY.FRAIS)}
                        />
                      </Grid>
                    )}
                    {!get(
                      props.showFees[props.victimId],
                      [FEES.MEDICAL_BENEFICIARY_FEES],
                      false,
                    ) &&
                      featureService.hasFeature(
                        FEATURES.JUDGEMENT_ON_MERITS_INFO,
                      ) && (
                        <Grid item xs={3}>
                          <TextField
                            type="number"
                            label={translate(messages.medicalFees, props)}
                            className="input-12"
                            name={BENEFICIARY.MEDICAL_FFES}
                            value={get(
                              beneficiary,
                              [BENEFICIARY.MEDICAL_FFES],
                              null,
                            )}
                            onChange={handleChange(BENEFICIARY.MEDICAL_FFES)}
                          />
                        </Grid>
                      )}
                    <Grid item xs={3}>
                      <TextField
                        label={translate(
                          messages.judgementAmountBeneficiary,
                          props,
                        )}
                        type="number"
                        name={BENEFICIARY.JUDGEMENT_AMOUNT}
                        onChange={handleChange(BENEFICIARY.JUDGEMENT_AMOUNT)}
                        value={get(
                          beneficiary,
                          [BENEFICIARY.JUDGEMENT_AMOUNT],
                          null,
                        )}
                        error={isNull(
                          get(
                            beneficiary,
                            [BENEFICIARY.JUDGEMENT_AMOUNT],
                            null,
                          ),
                        )}
                        className="input-12"
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label={translate(
                          messages.prejudiceMaterielTitle,
                          props,
                        )}
                        type="number"
                        className="input-12"
                        name={BENEFICIARY.PREJUDICE_MATERIEL}
                        value={get(
                          beneficiary,
                          [BENEFICIARY.PREJUDICE_MATERIEL],
                          null,
                        )}
                        onChange={handleChange(BENEFICIARY.PREJUDICE_MATERIEL)}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label={translate(messages.prejudiceMoralTitle, props)}
                        className="input-12"
                        type="number"
                        name={BENEFICIARY.PREJUDICE_MORAL}
                        value={get(
                          beneficiary,
                          [BENEFICIARY.PREJUDICE_MORAL],
                          null,
                        )}
                        onChange={handleChange(BENEFICIARY.PREJUDICE_MORAL)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormContainer>
                        <FormGroup>
                          <FormControlLabel
                            key={0}
                            control={
                              <Checkbox
                                checked={get(
                                  beneficiary,
                                  [BENEFICIARY.HANDICAP_INDICATOR],
                                  false,
                                )}
                                color="primary"
                                onChange={handleChangeCheckBox(
                                  BENEFICIARY.HANDICAP_INDICATOR,
                                )}
                              />
                            }
                            label={BENEFICIARY_OPTIONS[0]}
                          />
                          <FormControlLabel
                            key={1}
                            control={
                              <Checkbox
                                checked={get(
                                  beneficiary,
                                  [BENEFICIARY.DEPENDENT_INDICATOR],
                                  false,
                                )}
                                color="primary"
                                onChange={handleChangeCheckBox(
                                  BENEFICIARY.DEPENDENT_INDICATOR,
                                )}
                              />
                            }
                            label={BENEFICIARY_OPTIONS[1]}
                          />
                        </FormGroup>
                      </FormContainer>
                    </Grid>
                  </>
                )}
              </Grid>
              {featureService.hasFeature(
                FEATURES.REASONS_FOR_NON_COMPENSATION,
              ) &&
                get(judgement[id], BENEFICIARY_JUDGEMENT.FORM_REJECTION) && (
                  <BeneficiaryWithoutCompensation
                    beneficiary={beneficiary}
                    index={props.index}
                    deceasedVictimsToShow={props.deceasedVictimsToShow}
                    setDeceasedVictimsToShow={props.setDeceasedVictimsToShow}
                    setShowFuneralFees={props.setShowFees}
                    showFuneralFees={props.showFees}
                    lossDate={props.lossDate}
                    handleChangeBeneficiaries={
                      props.handleChangeNewBeneficiaries
                    }
                    handleChange={handleChange}
                    listings={props.listing}
                    isManager={props.isManager}
                    judgementOnMerits={props.judgementOnMerits}
                    mode={CIVIL_JUDGEMENT.FORM_REJECTION}
                    beneficiaryWithNonCompensation={get(
                      beneficiary,
                      'beneficiaryWithoutCompensation',
                      {},
                    )}
                    isNew={true}
                    victim={props.victim}
                  />
                )}
              {featureService.hasFeature(
                FEATURES.REASONS_FOR_NON_COMPENSATION,
              ) &&
                get(
                  judgement[id],
                  BENEFICIARY_JUDGEMENT.SUBSTANTIVE_REJECTION,
                ) && (
                  <BeneficiaryWithoutCompensation
                    beneficiary={beneficiary}
                    index={props.index}
                    deceasedVictimsToShow={props.deceasedVictimsToShow}
                    setDeceasedVictimsToShow={props.setDeceasedVictimsToShow}
                    setShowFuneralFees={props.setShowFees}
                    showFuneralFees={props.showFees}
                    lossDate={props.lossDate}
                    handleChangeBeneficiaries={
                      props.handleChangeNewBeneficiaries
                    }
                    handleChange={handleChange}
                    listings={props.listing}
                    victim={props.victim}
                    isManager={props.isManager}
                    judgementOnMerits={props.judgementOnMerits}
                    mode={CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION}
                    beneficiaryWithNonCompensation={get(
                      beneficiary,
                      'beneficiaryWithoutCompensation',
                      {},
                    )}
                    isNew={true}
                  />
                )}
              {!props.disableInput && (
                <div className="align-right">
                  <SecondaryButton
                    className="cancelButton"
                    onClick={handleCancel}
                    title={translate({ ...messages.cancelBtn }, props)}
                  />
                  <PrimaryButton
                    className="button-left-space"
                    onClick={handleSave}
                    title={translate({ ...messages.saveBtn }, props)}
                    disabled={ageValidation(
                      get(beneficiary, [BENEFICIARY.BENEFICIARY_TYPE]),
                      get(beneficiary, [BENEFICIARY.AGE]),
                    )}
                  />
                </div>
              )}
            </>
          </SahamAccordion>
        </Grid>
      </Grid>
    </Container>
  );
};

export default injectIntl(BeneficiaryAccordion);
